import React from 'react'
import { KeyboardArrowRight } from '@material-ui/icons'
import { useStyles } from './SmallScreenNavigationItem.styles'
import { Title } from 'components/ui/Typography/Title'
import { Clickable } from 'components/ui/Behaviors/Clickable'
import { IMenuItem } from '../../../../../hooks/useMenu'
import { SubMenu } from './SubMenu'
import clsx from 'clsx'

interface ISmallScreenNavigationItemProps {
  title: string
  onClick: () => void
  isSubMenu?: boolean
  items?: IMenuItem[]
}

export const SmallScreenNavigationItem = ({ title, onClick, isSubMenu, items }: ISmallScreenNavigationItemProps) => {
  const classes = useStyles()

  return (
    <>
      {isSubMenu && items ? (
        <SubMenu title={title} menuItems={items} />
      ) : (
        <Clickable onClick={onClick}>
          <div className={clsx(classes.root, classes.line)}>
            <Title>{title}</Title>
            <KeyboardArrowRight className={classes.arrow} />
          </div>
        </Clickable>
      )}
    </>
  )
}
